import axios from "axios";
import { Urls } from "./http/const";

export default axios.create({
  baseURL: Urls.baseURL, 
  headers: {
    "Content-type": "application/json",
  },
});
